/**
 * MotifLibrary.js
 * Source of Truth for Melodic Rhythm Templates.
 * Used by MelodyStrategies to seed the rhythm for melodic phrases.
 */

export const MOTIF_PATTERNS = {
    default: [{s:0, l:0.5}, {s:0.5, l:0.5}, {s:1.5, l:1.0}],
    fanfare: [{s:0, l:0.2}, {s:0.2, l:0.2}, {s:0.4, l:0.6}],
    lyrical_long: [{s:0, l:2.0}, {s:2.0, l:1.0}, {s:3.0, l:1.0}],
    riff_short: [{s:0, l:0.25}, {s:0.5, l:0.25}, {s:1.0, l:0.25}, {s:1.5, l:0.25}],
    staccato_run: [{s:0, l:0.2}, {s:0.25, l:0.2}, {s:0.5, l:0.2}, {s:0.75, l:0.2}, {s:2, l:0.5}],
    syncopated: [{s:0,l:0.75},{s:0.75,l:0.25},{s:1.0,l:0.5},{s:1.5,l:0.5},{s:2.5,l:1.5}],
    triplets:   [{s:0,l:0.33},{s:0.33,l:0.33},{s:0.66,l:0.33},{s:1,l:1}],
    slow:       [{s:0,l:2},{s:2,l:2}],
    chug_8ths:  [{s:0,l:0.5},{s:0.5,l:0.5},{s:1,l:0.5},{s:1.5,l:0.5},{s:2,l:0.5},{s:2.5,l:0.5},{s:3,l:0.5},{s:3.5,l:0.5}],
    // New Variants
    waltz_feel: [{s:0,l:1.0}, {s:1.0,l:0.5}, {s:1.5,l:0.5}], // 3/4ish feel in 4/4
    heroic_leap: [{s:0,l:1.5}, {s:1.5,l:0.5}, {s:2.0,l:2.0}],
    motor_16ths: [{s:0,l:0.25},{s:0.25,l:0.25},{s:0.5,l:0.25},{s:0.75,l:0.25},{s:1.0,l:0.5}],
    fragmented: [{s:0,l:0.5},{s:1.5,l:0.5},{s:3.0,l:0.5}]
};
